import { Stack } from '@mui/material';
import { DETAIL_STATUS, DetailStatusChip } from '../../../common/DetailStatusChip';
import { INVOICE_PAYMENT_STATUS } from '../../../utility/Constant';
import { formatCurrency } from '../../../utility/helpers/displayHelper';

/** Status chips on the invoice Finalized / Sent detail pages. Look and feel live in DETAIL_STATUS. */
export default function InvoiceStatusChips({ invoiceData, showGoogleReviewChip }) {
    const amountPending = invoiceData?.totalAmountPending ? Number(invoiceData?.totalAmountPending) : 0;

    const invoicePaymentStatus = invoiceData?.invoicePaymentStatus;

    const isShowBalanceRemaining = invoicePaymentStatus === INVOICE_PAYMENT_STATUS.PARTIALLY_PAID || invoicePaymentStatus === INVOICE_PAYMENT_STATUS.UNPAID;
    const isShowBalanceOwing = invoicePaymentStatus === INVOICE_PAYMENT_STATUS.OVER_PAID;
    const isFullyPaid = invoicePaymentStatus === INVOICE_PAYMENT_STATUS.FULLY_PAID;

    const isEmailSent = invoiceData?.isEmailSent;

    return (
        <Stack direction="row" justifyContent={'flex-start'} gap={2} mt={1} sx={{ flexWrap: 'wrap' }}>
            <DetailStatusChip status={isEmailSent ? DETAIL_STATUS.SENT : DETAIL_STATUS.FINALIZED} />

            {/* No Work Order chip on an invoice (client, 2026-09-24) — the "Linked to WO…" link covers it. */}

            {isShowBalanceOwing && (
                <DetailStatusChip status={DETAIL_STATUS.BALANCE_OWING} label={`Balance Owing: ${formatCurrency(Math.abs(+amountPending))}`} />
            )}

            {isFullyPaid && <DetailStatusChip status={DETAIL_STATUS.FULLY_PAID} />}

            {isShowBalanceRemaining && (
                <DetailStatusChip status={DETAIL_STATUS.BALANCE_REMAINING} label={`Balance Remaining: ${formatCurrency(amountPending)}`} />
            )}

            {showGoogleReviewChip && <DetailStatusChip status={DETAIL_STATUS.GOOGLE_REVIEW_REQUESTED} />}
        </Stack>
    );
}
